export const FORM_ID = 'edit_banking_details_form'
export const MODAL_NAME = 'EDIT_BANKING_DETAILS'
